module.exports = "/media/DueDateCalculator-Pic.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/tools/images/DueDateCalculator-Pic.jpg
// module id = 276
// module chunks = 0